// Auto-generated from appsettings.json AppData

export const appData = {
  extension_Logo: 'png',
  folderName_Logos: 'Logos',
  image_Extensions: 'jpg,jpeg,gif,png,svg,webp',
  image_MaxHeight: 1080,
  image_MaxMB: 2,
  image_MaxWidth: 1920,
  logoEmail_Name: 'logoEmail',
  logoEmail_Size: 200,
  logoIconPng_Extension: '.png',
  logoIconPng_Name: 'favicon-32x32',
  logoIconSvg_Extension: '.svg',
  logoIconSvg_Name: 'favicon',
  logoIcon_Size: 32,
  logoThumb_Name: 'logoThumb',
  logo_Name: 'logo',
  logo_Size: 500,
  thumbnail_Size: 200,
  thumbnail_Suffix: '_thumb',
} as const;

export type TAppData = typeof appData;
